<template>
  <div class="user_category" :key="this.$route.path">
    <div class="table_card mb-5">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg9 class="head_contain">
            <p class="table_card__head--title">Información General</p>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-1">
              <button
                class="faccess_button px-5"
                @click="
                  userCategoryId
                    ? (show_confirm_modal = true)
                    : createUserCategory()
                "
                :disabled="name.length < 2"
              >
                {{ userCategoryId ? "Editar plan" : "Crear plan" }}
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 lg6 class="pr-3">
            <label
              class="table_card__info--label"
              :class="{ 'custom_input__title--colapsed': name != '' }"
            >
              Nombre:
            </label>
            <input
              class="faccess_input"
              :class="{ 'custom_input__inputs--open': name != '' }"
              type="text"
              v-model="name"
            />
          </v-flex>
          <v-flex xs12 lg6 class="pl-3">
            <label
              class="table_card__info--label"
              :class="{ 'custom_input__title--colapsed': description != '' }"
            >
              Descripción:
            </label>
            <input
              class="faccess_input"
              :class="{ 'custom_input__inputs--open': description != '' }"
              type="text"
              v-model="description"
            />
          </v-flex>

          <v-flex xs12 lg6 class="pl-3">
            <v-switch
              class="data_card__switch"
              :label="'Limitar cantidad de accesos por día'"
              v-model="activate_access_limit_quantity"
              color="#1476FB"
            ></v-switch>
          </v-flex>
          <v-flex xs12 lg6 class="pl-3" v-show="activate_access_limit_quantity">
            <span class="table_card__info--label"
              >Máximo de accesos diarios por usuario</span
            >
            <div class="data_card__counter justified">
              <div class="justified__container">
                <button
                  class="faccess_counter__button"
                  @click="
                    access_limit_quantity > 1 ? access_limit_quantity-- : 1
                  "
                >
                  <img src="@/assets/img/icons/icono-menos.svg" />
                </button>
                <input
                  class="faccess_counter__input"
                  type="number"
                  name="Name"
                  :value="access_limit_quantity"
                  readonly
                />
                <button
                  class="faccess_counter__button"
                  @click="access_limit_quantity++"
                >
                  <img src="@/assets/img/icons/icono-mas.svg" />
                </button>
              </div>
            </div>
          </v-flex>
          <v-flex
            xs12
            lg6
            class="pl-3"
            v-if="getCompany().access.notify_access"
          >
            <v-switch
              class="data_card__switch"
              :label="'Notificar accesos'"
              v-model="report_access"
              color="#1476FB"
            ></v-switch>
          </v-flex>
          <v-flex xs12 lg6 class="pl-3">
            <v-switch
              class="data_card__switch"
              :label="'Enviar Invitación'"
              v-model="send_invitation"
              color="#1476FB"
            ></v-switch>
          </v-flex>
          <v-flex xs12 lg6 class="pl-3" v-if="getCompany().directory">
            <v-switch
              class="data_card__switch"
              :label="'Incluir en directorio'"
              v-model="add_to_directory"
              color="#1476FB"
            ></v-switch>
          </v-flex>
          <v-flex
            xs12
            lg6
            class="pl-3"
            v-if="getCompany().access.remote_open_door"
          >
            <v-switch
              class="data_card__switch"
              :label="'Apertura remota de puertas'"
              v-model="remote_open_door"
              color="#1476FB"
            ></v-switch>
          </v-flex>
        </v-layout>
      </div>
    </div>


    <div class="table_card">
    <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg9 class="head_contain">
            <p class="table_card__head--title">Sedes del plan</p>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-1">
              <button
                class="faccess_button px-5"
                @click="showAreasModal()"
                :disabled="this.location_selected.length < 1"     
              >
                {{ "Asignar áreas del plan"  }}
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>

    
      
      <div class="table_card__body" style="padding-bottom: 12px;">
        <v-checkbox
          v-for="location in available_locations"
          :key="location.location_id"
          v-model="location_selected"
          :label="location.name"
          :value="location.location_id"
          color="#1476FB"
          style="margin-top: 0px !important; padding-top: 0px !important"
        ></v-checkbox>
      </div>

      <div class="table_card__footer justify-content-start">
        <nav class="pagination" role="navegation" aria-label="pagination">
          <v-pagination :value="page" :length="pages" @input="changePage" />
        </nav>
      </div>
    </div>

    <section v-if="show_confirm_modal" class="access_devices__modal">
      <section class="access_devices__modal--container" style="width: 40%;">
        <p class="access_devices__modal--text" style="text-align: justify;">
          <b>AVISO:</b> Si las <b>sedes del plan</b> fueron cambiadas, los
          usuarios del plan serán <b>desvinculados</b> de las locaciones a las
          que esten relacionados.
        </p>
        <br />
        <p class="access_devices__modal--text">
          ¿Está seguro de editar el plan de usuario?
        </p>
        <div class="access_devices__modal--buttons" style="margin-top: 1rem;">
          <div
            class="access_devices__modal--button"
            @click="show_confirm_modal = false"
          >
            Cancelar
          </div>
          <div
            class="access_devices__modal--button active"
            @click="updateUserCategory"
          >
            Si
          </div>
        </div>
      </section>
    </section>

    <section v-if="show_areas_modal" class="access_devices__modal">
      <section
        class="access_devices__modal--container"
        style="width: 50%; max-height: 80vh; overflow-y: auto;"
      >
        
        <div v-if="available_areas_by_location.length === 0">
          
          <p class="access_devices__modal--text" style="text-align: center;">
            No hay áreas disponibles para las sedes seleccionadas.
          </p>
        </div>
        <div v-else>
          <p class="table_card__head--title" style="text-align: center;">
            Asignar Áreas del Plan : 
          </p>
          <div v-for="(areas, locationName) in groupedAreasByLocation" :key="locationName" style="margin-bottom: 1.5em;">
            <p style="font-weight: bold; margin-bottom: 0.5em;">{{ locationName }}</p>
            <v-checkbox
              v-for="area in areas"
              :key="area.id"
              v-model="area_selected"
              :label="area.name"
              :value="area.id"
              color="#1476FB"
              style="margin-top: 0px !important; padding-top: 0px !important"
            ></v-checkbox>
          </div>
  
        </div>
        <div
          class="access_devices__modal--buttons"
          style="margin-top: 1rem; justify-content: center;"
        >
          <div
            class="access_devices__modal--button active"
            @click="show_areas_modal = false"
          >
            Cerrar
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  props: ["userCategoryId"],
  data() {
    return {
      available_locations: [],
      location_selected: [],
      available_areas_by_location: [],
      area_selected: [],
      name: "",
      description: "",
      send_invitation: false,
      add_to_directory: false,
      activate_access_limit_quantity: false,
      report_access: false,
      remote_open_door: false,
      access_limit_quantity: 0,
      page: 1,
      pages: 1,
      show_confirm_modal: false,
      show_areas_modal: false
    };
  },
  watch: {
    userCategoryId: function(newVal) {
      if (newVal) {
        this.getUserCategory();
      } else {
        this.name = "";
        this.description = "";
        this.location_selected = [];
        this.send_invitation = false;
        this.add_to_directory = false;
        this.access_limit_quantity = 0;
        this.report_access = false;
      }
    },
    activate_access_limit_quantity(val) {
      if (val == false) {
        this.access_limit_quantity = 0;
      } else if (
        this.access_limit_quantity === 0 ||
        this.access_limit_quantity === null
      ) {
        this.access_limit_quantity = 1;
      }
    }
  },
  methods: {
    getLocations() {
      const data = { company: { id: this.getCompany().id } };
      try {
        this.$http
          .post(
            "locations/company",
            {
              data: this.encrypt(data).toString(),
              page: this.page
            },
            {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken()
              }
            }
          )
          .then(function(response) {
            this.sortAvailableLocations(response.body);
            this.pages = response.body.meta.pages;
          });
      } catch (e) {
        alert(e);
      }
    },
    sortAvailableLocations(dataResponse) {
      this.available_locations = [];
      for (var i = 0; i < dataResponse.data.length; i++) {
        if (dataResponse.data[i].attributes.published == true) {
          this.available_locations.push({
            location_id: parseInt(dataResponse.data[i].id),
            name: dataResponse.data[i].attributes.name
          });
        }
      }
      console.log("Available Locations: ", this.available_locations);
    },
    getUserCategory() {
      let params = {
        id: this.userCategoryId,
        company_id: this.getCompany().id
      };
      try {
        this.$http
          .get("user_categories/show", {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            },
            params
          })
          .then(function(response) {
            let {
              name,
              description,
              send_invitation,
              add_to_directory,
              report_access,
              access_doors,
              access_areas,
              access_limit_quantity,
              remote_open_door
            } = response.body;

            this.name = name;
            this.description = description;
            this.location_selected = access_doors;
            this.area_selected = access_areas;
            this.send_invitation = send_invitation;
            this.add_to_directory = add_to_directory;
            this.report_access = report_access;
            this.remote_open_door = remote_open_door;
            this.access_limit_quantity =
              access_limit_quantity !== null && access_limit_quantity > 0
                ? access_limit_quantity
                : 0;
            this.activate_access_limit_quantity =
              access_limit_quantity !== null && access_limit_quantity > 0
                ? true
                : false;
          });
      } catch (e) {
        alert(e);
      }
    },
    createUserCategory() {
      let data = {
        name: this.name,
        description: this.description,
        access_doors: this.location_selected,
        access_areas: this.area_selected,
        send_invitation: this.send_invitation,
        add_to_directory: this.add_to_directory,
        report_access: this.report_access,
        access_limit_quantity: this.access_limit_quantity,
        company_id: this.getCompany().id,
        remote_open_door: this.remote_open_door
      };
      this.$http
        .post(
          "user_categories/create",
          { data: this.encrypt(data).toString() },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            }
          }
        )
        .then(function(response) {
          this.updateAlertMessage("Plan de usuario creado satisfactoriamente");
          this.updateIsInAlert(true);
          this.$router.push({ name: "user_list_plans" });
        })
        .catch(function(response) {
          this.updateAlertMessage(response.body.errors[0].title);
          this.updateIsInAlert(true);
        });
    },
    updateUserCategory() {
      let data = {
        name: this.name,
        description: this.description,
        access_doors: this.location_selected,
        access_areas: this.area_selected,
        send_invitation: this.send_invitation,
        add_to_directory: this.add_to_directory,
        report_access: this.report_access,
        access_limit_quantity: this.access_limit_quantity,
        company_id: this.getCompany().id,
        remote_open_door: this.remote_open_door
      };
      console.log(data);
      this.$http
        .put(
          "user_categories/update",
          { data: this.encrypt(data).toString(), id: this.userCategoryId },
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            }
          }
        )
        .then(function(response) {
          this.updateAlertMessage(
            "Plan de usuario actualizado satisfactoriamente"
          );
          this.updateIsInAlert(true);
          this.$router.push({ name: "user_list_plans" });
        })
        .catch(function(response) {
          this.updateAlertMessage(response.body.errors[0].title);
          this.updateIsInAlert(true);
        });

      this.show_confirm_modal = false;
    },
    changePage(page) {
      this.page = page;
      this.getLocations();
    },

    getAreasByLocation(location_ids) {
     
      try {
        this.$http
          .post("areas/by_location", 
          {location_ids: location_ids},
          {
            headers: {
              "X-Device-ID": this.getDeviceId(),
              Authorization: "Bearer " + this.getUserToken()
            }
        
          })
          .then(function(response) {
            
            this.available_areas_by_location = [];
            if (response.body.data && response.body.data.length > 0) {
              response.body.data.forEach(location => {
                if (location.areas && location.areas.length > 0) {
                  location.areas.forEach(area => {
                    this.available_areas_by_location.push({
                      id: area.id,
                      name: area.name,
                      location_id: location.location_id,
                      location_name: location.location_name
                    });
                  });
                }
              });
            }
            console.log("Áreas procesadas:", this.available_areas_by_location);
          });
      } catch (e) {
        alert(e);
      }
    },
    showAreasModal() {
      this.getAreasByLocation(this.location_selected);
      this.show_areas_modal = true;
    }
  },
  mounted() {
    this.getLocations();
    console.log(this.getCompany());
    this.userCategoryId ? this.getUserCategory() : null;
  },
  computed: {
    groupedAreasByLocation() {
      // Agrupa las áreas por nombre de locación
      const groups = {};
      this.available_areas_by_location.forEach(area => {
        if (!groups[area.location_name]) {
          groups[area.location_name] = [];
        }
        groups[area.location_name].push(area);
      });
      return groups;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/access/UserCategory.vue